import axios, { resHandle } from "@/plugins/axios";



/**
 * @description 数据中心列表
 * @param vCom Vue组件
 */
const GetCenter = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/list/v2").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获取全部机构
 * @param vCom Vue组件
 */
const GetHospitals = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/user/hospitals", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

export {
    GetCenter, GetHospitals
};

